import React from 'react';
import { Link } from 'react-router-dom';
import { company, routes } from '../../models/content';

const phoneIcon = (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const mailIcon = (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

export default function V2CtaDark() {
  return (
    <div className="cta-dark">
      <div className="inner">
        <div>
          <h2 className="kicker">Get in Touch</h2>
          <div className="cta-lede">
            Revitalising <span className="it">resilient</span> businesses.
            <br />
            Catalysing <span className="it">exponential</span> growth.
          </div>
          <div className="actions">
            <Link to={routes.contact} className="btn btn-light btn-lg">
              Get in Touch →
            </Link>
          </div>
        </div>
        <div className="addr">
          <h2 className="kicker">Address</h2>
          <div className="body">
            1B, 1st Floor, Court Chambers,
            <br />
            35, Sir Vithaldas Thackersey Marg,
            <br />
            New Marine Lines, Mumbai - 400020
          </div>
          <div className="links">
            <a href={company.phoneHref}>
              <span className="link-icon" aria-hidden="true">
                {phoneIcon}
              </span>
              {company.phoneDisplay}
            </a>
            <a href={company.emailHref}>
              <span className="link-icon" aria-hidden="true">
                {mailIcon}
              </span>
              {company.emailDisplay}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
